// extracted by mini-css-extract-plugin
export default {"btn":"btn-UYpkcW","sponsored":"sponsored-ngCZhe","delete":"delete-jBtzBC","hollow":"hollow-c2XjVL","icon":"icon-HzlAz4","small":"small-hV5SUH","spin":"spin-zDRtIv"};